import { useState } from "preact/hooks"
import { useSort } from "@nosto/search-js/preact/hooks"
import Icon from "@/elements/Icon/Icon"
import { sortOptions } from "@/config"
import styles from "./SortAccordion.module.css"
import { cl } from "@nosto/search-js/utils"

type Props = {
  defaultActive?: boolean
}

export default function SortAccordion({ defaultActive = true }: Props) {
  const { activeSort, setSort } = useSort(sortOptions)
  const [active, setActive] = useState(defaultActive)

  const toggleActive = () => setActive(prev => !prev)

  const activeLabel = sortOptions.find(option => option.id === activeSort)?.value.name

  return (
    <div className={cl(styles.accordion, active && styles.active)}>
      <button
        type="button"
        className={styles.header}
        onClick={toggleActive}
        aria-controls="sort-accordion-panel"
        aria-expanded={active}
        aria-label={`${active ? "Collapse" : "Expand"} sort options`}
      >
        <span className={styles.title}>Sort By</span>
        {activeLabel && !active && <span className={styles.activeLabel}>{activeLabel}</span>}
        <span className={styles.icon}>
          <Icon name={active ? "minus" : "plus"} />
        </span>
      </button>
      <div className={styles.content} id="sort-accordion-panel" aria-hidden={!active}>
        <div className={styles.options}>
          {sortOptions.map(option => {
            const checked = option.id === activeSort
            const radioId = `sort-by-${option.id}`
            return (
              <label
                key={option.id}
                className={cl(styles.radio, checked && styles.checked)}
                htmlFor={radioId}
              >
                <input
                  id={radioId}
                  type="radio"
                  name="sort_by"
                  value={option.id}
                  checked={checked}
                  onChange={() => setSort(option.id)}
                />
                <span className={styles.indicator} />
                <span className={styles.label}>{option.value.name}</span>
              </label>
            )
          })}
        </div>
      </div>
    </div>
  )
}
